<template>
  <div :class="['agent-panel', { selected: selected }]" @click.prevent="$emit('click', $event)">
    <div class="agent-logo-container">
      <Avatar :name="agent.name" :image="agentProfilePicURL" :editable="false" :size="70" />
    </div>
    <div class="agent-info-container">
      <h3><strong>{{agent.name}}</strong></h3>
      <div class="online-marker"><i class="fas fa-circle icon-anim-pulse" /> Online</div>
      {{agent.title}}
    </div>
  </div>
</template>

<style lang="scss">
.agent-panel {
  background-color: #d3cebc;
  padding: 8px;
  border-radius: $layout-minor-border-radius;
  color: #424141;
  cursor: pointer;

  display: flex;
}
.agent-logo-container {
  width: 80px;
}
.agent-info-container {
  flex: 1;
}
.agent-panel.selected {
  background: #5a5955;
  color: #d8d2bd;
}
.agent-panel h3 {
  margin-bottom: 0;
}
.online-marker i {
  color: #87ff87;
  font-size: 6px;
}
.online-marker {
  font-size: 10px;
}
</style>

<script>
import Avatar from '@/components/avatar.vue'

export default {
  name: 'AIAgentPanel',
  components: {
    Avatar
  },
  props: {
    agent: Object,
    selected: Boolean
  },
  computed: {
    agentProfilePicURL() {
      return `/ai/images/${this.agent.avatarType}.png`
    }
  },
  methods: {
    
  }
}
</script>